document.addEventListener("DOMContentLoaded", function () {
    let loadMoreBtn = document.getElementById('load-more-btn');
    let itemsList = document.getElementById('store-list');
    let category_name = loadMoreBtn.name
    loadMoreBtn.addEventListener('click', function (e) {
        e.preventDefault();
        let offset = document.querySelectorAll('#store-list .storeBox3').length;
        
        $.ajax({
            url: "/" + category_name + "/stores_load_more",
            type: "GET",
            data: { offset: offset },
            success: function (data) {
                itemsList.innerHTML += data;
            },
            error: function (xhr, status, error) {
                console.error("Error loading more items:", error);
            }
        });
    });
});